export type MenuCatalogImportStatus = 'Success' | 'Failed' | 'Partial' | string;

export type MenuCatalogImportNotificationData = {
  batchId?: string;
  importKind?: string;
  status?: MenuCatalogImportStatus;
  message?: string;
  rowIssues?: { rowNumber?: number; message?: string }[];
};

export const IMPORT_SOURCES = new Set<string>([
  'inventory-item-batch-upload',
  'inventory-category-batch-upload',
]);
